import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { DomainAmazonOption } from '../types'
import { DomainAmazonSliceDTO } from './types'

export const domainAmazonsFromDTO = (from: DomainAmazonSliceDTO) =>
  mapDTO<DomainAmazonSliceDTO, DomainAmazonOption>({ from }).transform(
    (data: DomainAmazonSliceDTO): DomainAmazonOption => {
      const {
        domain: { activeAbTest, alerts, name },
        enabled,
        id,
      } = data

      return {
        activeAbTestId: activeAbTest ? activeAbTest.id : undefined,
        alerts: alertsFromDTO<DomainAlert>(alerts),
        enabled,
        label: name,
        value: id,
      }
    },
  )
